import { createSelector } from "reselect";
import { get } from "lodash";

/**
 * Not a selector, but a helper function that can be used to slugify titles
 * @param {string} the title that will be sligified
 */
export const slugify = (title) => title.toLowerCase().replace(" ", "-");

export const slugifyMatch = createSelector(
  (_, props) => props.match,
  (match) => slugify(get(match, "params.collections", ""))
);

export const loadVideos = createSelector(
  [(state) => state.search, (state) => get(state, "playlists.playlistVideos")],
  (search, playlistVideos) => {
    const list = get(search, "results.length", 0)
      ? get(search, "results", []).map((it) => it.fields)
      : get(playlistVideos, "videos", []).map((it) => it.video);

    return {
      loading: playlistVideos.fetching && list.length === 0 ? true : false,
      list,
    };
  }
);
